// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1iQfd","fileDisabled":"File_fileDisabled__3-uc9"};